import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { ActivityPinger } from '@/components/activity-pinger.tsx';
import { LearnerShell } from '@/components/learner-shell.tsx';
import { useAuth } from '@/store/auth.ts';

// 学习区（STUDENT / TEACHER）的无路径布局。守卫在任何子路由加载前运行；
// ADMIN 跳转到 /admin，匿名用户跳转到 /login。
export const Route = createFileRoute('/_learner')({
  beforeLoad: () => {
    const { user } = useAuth.getState();
    if (!user) throw redirect({ to: '/login' });
    if (user.role === 'ADMIN') throw redirect({ to: '/admin' });
  },
  component: LearnerLayout,
});

function LearnerLayout() {
  // beforeLoad guarantees a non-admin user here; the `!user` guard is a render-time
  // safety net (e.g. after logout clears the store before navigation settles).
  const user = useAuth((s) => s.user);
  if (!user) return null;
  return (
    <LearnerShell user={user}>
      {/* ADR-013: student daily presence ping (feeds user_activity → ACCESS metric) */}
      {user.role === 'STUDENT' && <ActivityPinger />}
      <Outlet />
    </LearnerShell>
  );
}
